import { createSlice } from '@reduxjs/toolkit';

import { RootState } from '..';
import {
  adminCreateSubTopic,
  adminDeleteSubTopic,
  adminUpdateSubTopic,
} from '../SubTopicSlice';
import {
  adminApproveQuestion,
  adminCreateNewQuestion,
  adminUpdateQuestion,
  adminDeleteQuestion,
} from '../QuestionSlice';
import {
  createCourseAsAdmin,
  deleteCourseAsAdmin,
  updateCourseAsAdmin,
} from '../V2/CoursesSlice/adminApi';
import {
  finishSubmission,
  showSubmissionQuestionAnswer,
} from '../SubmissionSlice';
import { adminCreateQuiz, adminPublishQuiz } from '../QuizSlice';
import { startTrial } from '../Trial';
import { adminUpdateTopicSorting } from '../TopicSlice/TopicAdminApi';
import { reportResources } from '../ResourcesSlice';
import { requestCallback } from '../DiagnosticSlice';
import { deleteCourseSectionByIdAsAdmin } from '../V2/SectionSlice';
import {
  createCourseTutor,
  deleteCourseTutor,
  updateCourseTutor,
} from '../V2/CourseTutorsSlice';
import {
  createCourseStudent,
  deleteCourseStudent,
  updateCourseStudent,
} from '../V2/CourseStudentsSlice';

export interface IinitialState {
  visible: boolean;
  message: string;
}

const initialState: IinitialState = {
  visible: false,
  message: '',
};

export const SuccessSlice = createSlice({
  name: 'error',
  initialState,
  reducers: {
    resetMessage: (state) => {
      state.visible = false;
      state.message = '';
    },
  },
  extraReducers: (builder) => {
    builder
      // Subtopic Slice
      .addCase(adminCreateSubTopic.fulfilled, (state) => {
        state.visible = true;
        state.message = 'Sub topic Added';
      })
      .addCase(adminDeleteSubTopic.fulfilled, (state) => {
        state.visible = true;
        state.message = 'Sub topic Deleted';
      })
      .addCase(adminUpdateSubTopic.fulfilled, (state) => {
        state.visible = true;
        state.message = 'Sub topic Updated';
      })
      .addCase(adminApproveQuestion.fulfilled, (state, action) => {
        if (action.payload.isApproved) {
          state.visible = true;
          state.message = 'Question approved';
        } else {
          state.visible = true;
          state.message = 'Question un-approved';
        }
      })
      // Question Slice
      .addCase(adminCreateNewQuestion.fulfilled, (state) => {
        state.visible = true;
        state.message = 'Question Created';
      })
      .addCase(adminUpdateQuestion.fulfilled, (state) => {
        state.visible = true;
        state.message = 'Question Updated';
      })
      .addCase(adminDeleteQuestion.fulfilled, (state) => {
        state.visible = true;
        state.message = 'Question Deleted';
      })
      // Quiz Slice
      .addCase(adminCreateQuiz.fulfilled, (state) => {
        state.visible = true;
        state.message = 'Quiz Created';
      })
      .addCase(adminPublishQuiz.fulfilled, (state) => {
        state.visible = true;
        state.message = 'Quiz updated';
      })
      // Submission Slice
      .addCase(finishSubmission.fulfilled, (state) => {
        state.visible = true;
        state.message = 'Quiz Completed';
      })
      .addCase(showSubmissionQuestionAnswer.fulfilled, (state) => {
        state.visible = true;
        state.message = 'Answer is now Visible';
      })
      // Trial Slice
      .addCase(startTrial.fulfilled, (state) => {
        state.visible = true;
        state.message = 'Quiztopiya 1 day Free Trial Started!';
      })
      // Topic Slice
      .addCase(adminUpdateTopicSorting.fulfilled, (state) => {
        state.visible = true;
        state.message = 'Topics updated!';
      })
      // Report Resources Slice
      .addCase(reportResources.fulfilled, (state) => {
        state.visible = true;
        state.message = 'Issue reported successfully!';
      })
      // Diagnostic Slice
      .addCase(requestCallback.fulfilled, (state) => {
        state.visible = true;
        state.message =
          'Thank you for requesting callback. Our team will reach out to you shortly';
      })
      // =====================================================================
      // V2
      .addCase(createCourseAsAdmin.fulfilled, (state) => {
        state.visible = true;
        state.message = 'Course Created!';
      })
      .addCase(updateCourseAsAdmin.fulfilled, (state) => {
        state.visible = true;
        state.message = 'Course Updated!';
      })
      .addCase(deleteCourseAsAdmin.fulfilled, (state) => {
        state.visible = true;
        state.message = 'Course Deleted!';
      })
      .addCase(deleteCourseSectionByIdAsAdmin.fulfilled, (state) => {
        state.visible = true;
        state.message = 'Section Deleted!';
      })
      .addCase(createCourseTutor.fulfilled, (state) => {
        state.visible = true;
        state.message = 'Tutor Added!';
      })
      .addCase(deleteCourseTutor.fulfilled, (state) => {
        state.visible = true;
        state.message = 'Tutor Deleted!';
      })
      .addCase(updateCourseTutor.fulfilled, (state) => {
        state.visible = true;
        state.message = 'Tutor Updated!';
      })
      .addCase(createCourseStudent.fulfilled, (state) => {
        state.visible = true;
        state.message = 'Student Added!';
      })
      .addCase(deleteCourseStudent.fulfilled, (state) => {
        state.visible = true;
        state.message = 'Student Deleted!';
      })
      .addCase(updateCourseStudent.fulfilled, (state) => {
        state.visible = true;
        state.message = 'Student Updated!';
      });
  },
});

export const { resetMessage } = SuccessSlice.actions;

export const getSuccessState = (state: RootState): RootState['success'] =>
  state.success;

export default SuccessSlice.reducer;
